import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import LayoutFull from '../../../layouts/layoutFull/LayoutFull';
import styles from './builder.module.scss';
import { DEBUG, NAME_PROJECT, } from "../../../settings/global";
import { SeoCommon, SeoOpenGraph } from "../../../helpers/seo/seo";
import { getTable } from "../../../helpers/data/get/database";
import { cliError } from "../../../helpers/cli/colors";
import { convertEditorStateToHTML } from "../../../components/draftEditor/export/exports";
import { Block } from "../../../layouts/Content";
import Builder from "../../../pagesComponents/deployment/custom/builder/Builder";
import Projects from "../../../pagesComponents/deployment/custom/projects/Projects";
import CloudConnector from "../../../pagesComponents/deployment/custom/cloud/CloudConnector";
import { useRouter } from "next/router";
import {
    setDeploymentApp,
    setDeploymentApps,
    setDeploymentMessages,
    updateBodyBuilder,
    wipeBodyBuilder
} from "../../../redux/actions/DeploymentActions";
import Deployments from "../../../pagesComponents/deployment/custom/deployments/Deployments";
import DeploymentDebug from "../../../pagesComponents/deployment/_components/DeploymentDebug";
import { getProjects } from "../../../pagesComponents/deployment/custom/_fetch/projects/get";
import FeatureInit from "../../../pagesComponents/deployment/_init/FeaturesInit";
import tawkToChat from "../../../components/TawkToChat";
import { setPaymentData, setPlans, setSubscriptions } from "../../../redux/actions/CommonDataActions";
import { projectSave } from "../../../pagesComponents/deployment/custom/_fetch/project/post";
import {
    BUILDER_DATA,
    CUSTOM_STACK_NAME,
    NAV_BUILDER_FLOW,
    NAV_BUILDER_FLOW_NAME,
    NAV_CUSTOM_STACK,
    NAV_PROJECT_BUILDER_URL,
    NAV_PROJECT_COMPOSE_URL,
    NAV_PROJECT_DEPLOYMENT_URL,
    NAV_PROJECT_DEPLOYMENTS_URL
} from "../../../settings/content/deploymentStacker";
import { projectDelete } from "../../../pagesComponents/deployment/custom/_fetch/project/delete";
import isEqual from 'lodash.isequal'
import { collectBuilderMessages } from "../../../pagesComponents/deployment/custom/_helpers/messages";
import Breadcrumb, { BreadcrumbLayer } from "../../../components/Breadcrumb";
import Compose from "../../../pagesComponents/deployment/custom/compose/Compose";
import { generateSlug, immutableArraySlice, scrollToAnchor } from "../../../helpers/common";
import { projectCompose } from "../../../pagesComponents/deployment/custom/_fetch/project/compose";
import RippleLayout from "../../../components/ripple/RippleLayout";
import Loading from "../../../components/Loading";
import { validateDeployment } from "../../../pagesComponents/deployment/_fetch/precheck";
import Link from "next/link";
import {
    prepareCloudsAndPaymentData,
    preparePlansAndSubscriptions,
    prepareSslData
} from "../../../pagesComponents/deployment/_helpers/serverSiideHelpers";
import { NAV_STACK_LIST } from "../../../settings/navigation";

export async function getStaticProps({params}) {

    let appsData = {web: [], service: [], feature: [],};

    const formatToArray = col => col.map(i => i[Object.keys(i)[0]]);

    const category = `category:app_category!category_id(name)`;
    const versions = `versions:app_version(_id,name,version,update_status,tag)`;
    const appGroup = `group:app_group_app(app_group(*))`;
    const link = `link:app_link(link(url,title,type,follow))`;
    const githubLink = `githubLink:app_github(github(repo_owner,repo_name,type,follow))`;
    let apps = await getTable(`app?select=*,${category},${link},${githubLink},${appGroup},${versions}`);

    apps = apps.sort((a, b) => ('' + a.name).localeCompare(b.name));
    apps = apps.filter(a => !!a.docker_image_is_internal);

    apps.map(a => {

        if (!a.type) {
            cliError(`${a.name || a.code} doesn't have a "type" property`);
            throw (`${a.name || a.code} doesn't have a "type" property`);
        }

        if (a.type !== 'web' && a.type !== 'service' && a.type !== 'feature') {
            cliError(`${a.name || a.code} shares an unrecognized "type=${a.type}" value.`);
            throw (`${a.name || a.code} shares an unrecognized "type=${a.type}" value.`);
        }

        a.links = [...formatToArray(a.link), ...formatToArray(a.githubLink)];
        // remove temp data from db query (otherwise might be a potential conflict and excessive data)
        delete a.link;
        delete a.githubLink;

        appsData[a.type].push({
            ...a,
            ...{
                description:
                    a.description?.blocks?.some?.(b => !!b.text)
                        ? convertEditorStateToHTML(a.description, {})
                        : null,
                category: Array.isArray(a.category) ? a.category : [a.category], // for some bloody reason db responds with object if it's a single entry and makes a conflicts with view from basic deployment
                group: formatToArray(a.group),
                versions: a.versions.filter(v => v.update_status === 'published'),
                cpu: !!a.cpu && !isNaN(parseFloat(a.cpu)) ? parseFloat(a.cpu).toFixed(1) : '0',
            }
        });
    });

    const {categories, tags, paymentData, clouds} = await prepareCloudsAndPaymentData();
    const {plansData, subscriptionsData} = await preparePlansAndSubscriptions();

    return {
        props: {
            // common
            clouds,
            paymentData,
            plansData,
            subscriptionsData,
            ssl: await prepareSslData(),
            // builder
            tags,
            categories,
            stackData: BUILDER_DATA,
            stackComing: false,
            stackHidden: false,
            appsData,
        }
    };
}

function Deployment({
                        stackData,
                        clouds, paymentData, plansData, subscriptionsData,
                        appsData,
                        categories, tags, // custom deployment
                        user, userFetchStatus,
                        bodyBuilder, bodyStack, bodyServer, bodyCloud,
                        messages, messagesResponse, errorsInputs,
                        debug,
                        ssl,
                        dispatch,
                    }) {

    const router = useRouter();

    const [project, setProject] = useState(undefined);
    const [projects, setProjects] = useState([]);
    const [projectsStatus, setProjectsStatus] = useState('loading');
    const [projectCreateStatus, setProjectCreateStatus] = useState(undefined);
    const [isWipeProcess, setIsWipeProcess] = useState(false);
    const [modified, setModified] = useState(false);
    const [compose, setCompose] = useState(null);
    const [cloudConnected, setCloudConnected] = useState(false);
    const [token, setToken] = useState(null);

    // set common data
    useEffect(() => {
        tawkToChat();
        dispatch(setPlans(plansData));
        dispatch(setPaymentData(paymentData));
        dispatch(setDeploymentApps(appsData));
        dispatch(setDeploymentApp(stackData));
        dispatch(setSubscriptions(subscriptionsData));
    }, []);

    useEffect(() => {
        if (userFetchStatus === 'success') {
            getProjects({setProjects, setProjectsStatus});
        }
    }, [userFetchStatus])
    // isWipeProcess old deployment data to set new
    useEffect(() => {
        dispatch(wipeBodyBuilder());
        setProject(undefined);
        setIsWipeProcess(true);
    }, [router.query.project])
    // handle query change and set project if valid query
    useEffect(() => {
        if (isWipeProcess && projectsStatus === 'success') {
            if (!!router.query.project) {
                const foundProject = projects.find(p => p.id + '' === router.query.project);
                if (!!foundProject) {
                    setProject(foundProject);
                    dispatch(updateBodyBuilder(foundProject?.request_json?.custom || {}));
                } else {
                    router.replace(router.pathname);
                }
            } else {
                router.replace(router.pathname);
            }
            setIsWipeProcess(false);
        }
    }, [router.query.project, projectsStatus, isWipeProcess]);

    useEffect(() => {
        if (!isWipeProcess && projectsStatus === 'success' && !!project) {
            const found = projects.find(p => p.id === project.id)?.request_json?.custom;
            setModified(!isEqual(found, bodyBuilder));
        }
    }, [bodyBuilder, projectsStatus, isWipeProcess, project]);

    useEffect(() => {
        scrollToAnchor('builder-container', null, true, 'builder-container');
    }, [router.query.section]);

    useEffect(() => {
        collectBuilderMessages(
            {...bodyStack, ...bodyBuilder, ...bodyServer, ...bodyCloud, ...{token}},
            messagesResponse
        );
    }, [bodyStack, bodyBuilder, bodyServer, bodyCloud, messagesResponse, errorsInputs, token]);

    const onProjectCreate = () => {
        setProjectCreateStatus('loading');
        projectSave({
            onSuccess: res => {
                getProjects({
                    setProjects,
                    setProjectsStatus,
                    onSuccess: () => {
                        setProjectCreateStatus('success');
                        router.push(`${NAV_BUILDER_FLOW}?project=${res?.item?.id}`)
                    }
                })
            },
            onError: () => {
                setProjectCreateStatus('error');
                getProjects({setProjects, setProjectsStatus})
            },
        });
    }

    const sectionURL = `${NAV_STACK_LIST}/${generateSlug(CUSTOM_STACK_NAME)}/builder?project=${project?.id}&section=`;
    const rerouteToDefaults = () => router.push(`${sectionURL}${NAV_PROJECT_BUILDER_URL}`);

    const onProjectSave = ({onSuccess, onError}) => {
        projectSave({
            onSuccess: (res) => {
                // setProjectCreateStatus('success');
                setCompose(null);
                getProjects({setProjects, setProjectsStatus});
                if (onSuccess) onSuccess(res);
            },
            onError: (res) => {
                // setProjectCreateStatus('error');
                if (res.responseBody?.message === `Can not access docker image` && res.responseBody?.item?.id) {
                    setTimeout(() => scrollToAnchor(`app-${res.responseBody?.item?.id}-dockerhub`, null, true, 'builder-container'), 1);
                    const fillError = field => ({
                        message: `Can not access docker image`,
                        type: 'error',
                        container: 'services',
                        block: `app-${res.responseBody?.item?.id}`,
                        target: `app-${res.responseBody?.item?.id}-dockerhub`,
                        part: `app-${res.responseBody?.item?.id}-dockerhub-${field}`,
                    });
                    dispatch(setDeploymentMessages([
                        ...messages,
                        ...[fillError(`user`)],
                        ...[fillError(`name`)],
                        ...[fillError(`pass`)],
                    ]));
                }
                getProjects({setProjects, setProjectsStatus});
                if (onError) onError(res);
            },
            deploymentID: project.id,
        });
    }

    const onBuilderConfirm = () => {

        if (!bodyBuilder.web?.length && !bodyBuilder.service?.length && !bodyBuilder.feature?.length) {
            setTimeout(() => scrollToAnchor('services', null, true, 'builder-container'), 1);
            const emptyMessage = {message: 'no-apps', type: 'error', container: 'services'};
            dispatch(setDeploymentMessages([...messages, ...[emptyMessage]]));
            setTimeout(() => {
                dispatch(setDeploymentMessages(immutableArraySlice(emptyMessage, messages, 'message')))
            }, 4000);
        } else {
            onProjectSave({
                onSuccess: () => {
                    projectCompose({
                        deploymentID: project.id,
                        compose: true,
                        onSuccess: res => {
                            router.push(`${sectionURL}${NAV_PROJECT_DEPLOYMENT_URL}`);
                            setCompose(res.item)
                        }
                    })
                }
            })
        }
    };

    const onCloudConfirm = () => {
        if (!debug.disablePreCheck && !token) {
            validateDeployment({
                onSuccess: response => {
                    setCloudConnected(true);
                    router.push(`${sectionURL}${NAV_PROJECT_COMPOSE_URL}`);
                },
                onError: response => {
                    setCloudConnected(false);
                },
                custom: true,
            });
        } else {
            setCloudConnected(true);
            router.push(`${sectionURL}${NAV_PROJECT_COMPOSE_URL}`);
        }
    }

    const onDeploy = () => {
        router.push(`${sectionURL}${NAV_PROJECT_DEPLOYMENTS_URL}`);
    }

    const onProjectDelete = (id) => {
        projectDelete({
            deploymentID: id,
            onSuccess: () => {
                setProjectCreateStatus('success');
                getProjects({
                    setProjects,
                    setProjectsStatus,
                    onSuccess: () => {
                        if (id === project.id) router.push(router.pathname);
                    }
                })
            },
            onError: () => {
                setProjectCreateStatus('error');
                getProjects({setProjects, setProjectsStatus})
            },
        });
    };

    const renderCreate = () => {
        return (
            <div className={styles.new}>
                {
                    !!projects?.length &&
                    <div className={styles.new__select}>
                        <i className={`fas fa-reply ${styles.new__select__icon}`}/>
                        <p>Pick a project from left menu</p>
                    </div>
                }
                <div className={styles.new__create}>
                    <RippleLayout
                        className={styles.new__create__ripple}
                        onClick={onProjectCreate}

                    >
                        <p>Create new project</p>
                        <i className={`fas fa-plus`}/>
                    </RippleLayout>
                </div>
            </div>
        )
    }

    const renderComponent = () => {

        const builderComponent = (
            <Builder
                project={project}
                projects={projects}
                onProjectSave={onProjectSave}
                onBuilderConfirm={onBuilderConfirm}
                onProjectCreate={onProjectCreate}
                projectCreateStatus={projectCreateStatus}
                appsData={appsData}
                stackData={stackData}
                categories={categories}
                tags={tags}
            />
        );

        switch (router.query.section) {
            case NAV_PROJECT_BUILDER_URL:
                return builderComponent;
            case NAV_PROJECT_DEPLOYMENT_URL:
                return (
                    <CloudConnector
                        modified={modified}
                        project={project}
                        projectsStatus={projectsStatus}
                        compose={compose}
                        clouds={clouds}
                        appsData={appsData}
                        stackData={stackData}
                        onCloudConfirm={onCloudConfirm}
                        token={token}
                        setToken={setToken}
                        rerouteCondition={modified || !compose}
                        rerouteToDefaults={rerouteToDefaults}
                    />
                );
            case NAV_PROJECT_COMPOSE_URL:
                return (
                    <Compose
                        modified={modified}
                        project={project}
                        projectsStatus={projectsStatus}
                        compose={compose}
                        onDeploy={onDeploy}
                        token={token}
                        rerouteCondition={!compose || modified || !cloudConnected}
                        rerouteToDefaults={rerouteToDefaults}
                    />
                );
            case NAV_PROJECT_DEPLOYMENTS_URL:
                return (
                    <Deployments
                        project={project}
                        clouds={clouds}
                        user={user}
                        userFetchStatus={userFetchStatus}
                        ssl={ssl}
                    />
                );
            default:
                return builderComponent
        }
    }

    return <>
        <LayoutFull scrollTopButton={{hide: true}} auth>
            <SeoCommon tags={{
                title: `${NAME_PROJECT} stack builder`,
                description: `Easy deploy your applications using ${NAME_PROJECT}`,
            }}/>
            <SeoOpenGraph tags={{
                title: `${NAME_PROJECT} stack builder`,
                description: `Easy deploy your applications using ${NAME_PROJECT}`,
            }}/>
            <div className={styles.layout} data-mobile-menu={!router.query.section}>
                <Block className={styles.layout__project}>
                    <div className={styles.layout__project__container}>
                        <Projects
                            compose={compose}
                            modified={modified}
                            user={user}
                            userFetchStatus={userFetchStatus}
                            projects={projects}
                            setProjectsList={setProjects}
                            projectsStatus={projectsStatus}
                            setProjectsStatus={setProjectsStatus}
                            dispatch={dispatch}
                            onProjectCreate={onProjectCreate}
                            onProjectDelete={onProjectDelete}
                            cloudConnected={cloudConnected}
                        />
                    </div>
                </Block>
                <div
                    style={{
                        backgroundColor: router.query.section === NAV_PROJECT_DEPLOYMENTS_URL
                            ? `var(--colorBackgroundBasic)`
                            : `var(--colorBackgroundContent)`
                    }}
                    className={styles.layout__builder}
                    id='builder-container'
                >
                    {
                        !project
                            ?
                            <Breadcrumb className={styles.layout__builder__breadcrumb}>
                                <BreadcrumbLayer link='/' name='Home'/>
                                <BreadcrumbLayer link={NAV_STACK_LIST} name='Applications' internal/>
                                <BreadcrumbLayer
                                    link={NAV_STACK_LIST + NAV_CUSTOM_STACK}
                                    name={CUSTOM_STACK_NAME}
                                />
                                <BreadcrumbLayer
                                    link={NAV_BUILDER_FLOW}
                                    name={NAV_BUILDER_FLOW_NAME}
                                />
                            </Breadcrumb>
                            :
                            <Breadcrumb className={styles.layout__builder__breadcrumb}>
                                <BreadcrumbLayer link='/' name='Home'/>
                                <BreadcrumbLayer link={NAV_STACK_LIST} name='Applications' internal/>
                                <BreadcrumbLayer
                                    link={NAV_STACK_LIST + NAV_CUSTOM_STACK}
                                    name={CUSTOM_STACK_NAME}
                                />
                                <BreadcrumbLayer
                                    link={NAV_BUILDER_FLOW}
                                    name={NAV_BUILDER_FLOW_NAME}
                                />
                                <BreadcrumbLayer
                                    link={NAV_STACK_LIST + NAV_CUSTOM_STACK}
                                    name={project?.body?.custom?.project_name || 'Undefined name'}
                                />
                            </Breadcrumb>
                    }
                    {
                        !!project &&
                        <Link
                            href={`${NAV_STACK_LIST}/${generateSlug(CUSTOM_STACK_NAME)}/builder?project=${project.id}`}
                            className={styles.layout__builder__back}>
                            <i className={`fas fa-chevron-left`}/>Back to project or step select
                        </Link>
                    }
                    {
                        projectsStatus === 'error'
                            ? null
                            :
                            !project
                                ? (projectsStatus === 'loading' || isWipeProcess) ? <Loading/> : renderCreate()
                                :
                                <div className={styles.layout__builder__container}>
                                    {renderComponent()}
                                    {
                                        !!DEBUG && !!project && router.query?.section !== NAV_PROJECT_DEPLOYMENTS_URL &&
                                        <div style={{padding: '0', width: '100%'}}>
                                            <DeploymentDebug custom/>
                                        </div>
                                    }
                                </div>
                    }
                </div>
            </div>
        </LayoutFull>
        {/* init */}
        <FeatureInit
            featuresDataCustom={appsData.feature || []}
            subscriptions={subscriptionsData}
            custom
        />
    </>;
}

const mapStateToProps = state => ({
    user: state.userData.user,
    userFetchStatus: state.userData.userFetchStatus,
    bodyBuilder: state.deployment.bodyBuilder,
    bodyStack: state.deployment.bodyStack,
    bodyServer: state.deployment.bodyServer,
    bodyCloud: state.deployment.bodyCloud,
    messages: state.deployment.messages,
    messagesResponse: state.deployment.messagesResponse,
    errorsInputs: state.deployment.errorsInputs,
    debug: state.deployment.debug,
})

export default connect(mapStateToProps)(Deployment)